/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { TimeRangeSelectorSettings } from '../types';
// @ts-ignore
import type { UpdateTimeRangeSelectorSettingsUpdateBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * TimeRangeSelectorApi - axios parameter creator
 * @export
 */
export const TimeRangeSelectorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns TimeRangeSelectorSettings for a Dashboard.
         * @summary Get TimeRangeSelectorSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeRangeSelectorSettingsForDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getTimeRangeSelectorSettingsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/time_range_selector_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates TimeRangeSelectorSettings.
         * @summary Update TimeRangeSelectorSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateTimeRangeSelectorSettingsUpdateBody} [updateTimeRangeSelectorSettingsUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeRangeSelectorSettings: async (dashboardId: string, updateTimeRangeSelectorSettingsUpdateBody?: UpdateTimeRangeSelectorSettingsUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateTimeRangeSelectorSettings', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/time_range_selector_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTimeRangeSelectorSettingsUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeRangeSelectorApi - functional programming interface
 * @export
 */
export const TimeRangeSelectorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeRangeSelectorApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns TimeRangeSelectorSettings for a Dashboard.
         * @summary Get TimeRangeSelectorSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeRangeSelectorSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeRangeSelectorSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeRangeSelectorSettingsForDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeRangeSelectorApi.getTimeRangeSelectorSettingsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates TimeRangeSelectorSettings.
         * @summary Update TimeRangeSelectorSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateTimeRangeSelectorSettingsUpdateBody} [updateTimeRangeSelectorSettingsUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimeRangeSelectorSettings(dashboardId: string, updateTimeRangeSelectorSettingsUpdateBody?: UpdateTimeRangeSelectorSettingsUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeRangeSelectorSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimeRangeSelectorSettings(dashboardId, updateTimeRangeSelectorSettingsUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeRangeSelectorApi.updateTimeRangeSelectorSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TimeRangeSelectorApi - factory interface
 * @export
 */
export const TimeRangeSelectorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeRangeSelectorApiFp(configuration)
    return {
        /**
         * Returns TimeRangeSelectorSettings for a Dashboard.
         * @summary Get TimeRangeSelectorSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeRangeSelectorSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<TimeRangeSelectorSettings> {
            return localVarFp.getTimeRangeSelectorSettingsForDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates TimeRangeSelectorSettings.
         * @summary Update TimeRangeSelectorSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateTimeRangeSelectorSettingsUpdateBody} [updateTimeRangeSelectorSettingsUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeRangeSelectorSettings(dashboardId: string, updateTimeRangeSelectorSettingsUpdateBody?: UpdateTimeRangeSelectorSettingsUpdateBody, options?: RawAxiosRequestConfig): AxiosPromise<TimeRangeSelectorSettings> {
            return localVarFp.updateTimeRangeSelectorSettings(dashboardId, updateTimeRangeSelectorSettingsUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeRangeSelectorApi - object-oriented interface
 * @export
 * @class TimeRangeSelectorApi
 * @extends {BaseAPI}
 */
export class TimeRangeSelectorApi extends BaseAPI {
    /**
     * Returns TimeRangeSelectorSettings for a Dashboard.
     * @summary Get TimeRangeSelectorSettings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeRangeSelectorApi
     */
    public getTimeRangeSelectorSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return TimeRangeSelectorApiFp(this.configuration).getTimeRangeSelectorSettingsForDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates TimeRangeSelectorSettings.
     * @summary Update TimeRangeSelectorSettings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {UpdateTimeRangeSelectorSettingsUpdateBody} [updateTimeRangeSelectorSettingsUpdateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeRangeSelectorApi
     */
    public updateTimeRangeSelectorSettings(dashboardId: string, updateTimeRangeSelectorSettingsUpdateBody?: UpdateTimeRangeSelectorSettingsUpdateBody, options?: RawAxiosRequestConfig) {
        return TimeRangeSelectorApiFp(this.configuration).updateTimeRangeSelectorSettings(dashboardId, updateTimeRangeSelectorSettingsUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}

